import * as THREE from 'three'
import showDragDropOverlay from '../../Utils/showDragDropOverlay.js'
import showThreejsJourney from '../../Utils/showDialogOverlay.js'
import ProjectBoardMaterial from '../../Materials/ProjectBoard.js'
import ScoreManager from '../../Utils/ScoreManager.js'
import  showScoreRequirementDialog  from '../../Utils/showScoreRequirementDialog.js'
import showIntroOverlay from '../../Utils/showIntroOverlay.js'
import showQAOverlay from '../../Utils/showQAOverlay.js'
import showThreejsJourney1 from '../../Utils/showThreejsJourney1.js'
import showStoryDialog from '../../Utils/showStoryOverlay.js'
import showQuizOverlay from '../../Utils/showQuizOverlay.js'
import showStakeholderOverlay from '../../Utils/stakeholderOverlay.js'
import showWiderstandPopup from '../../Utils/wiederstandStation.js'
import showMiroBoard from '../../Utils/miroBoard.js'
import showPopupStationOverlay from '../../Utils/popupStationOverlay.js'
import showKennzahlenOverlay from '../../Utils/showKennzahlen.js'
import showChecklistOverlay from '../../Utils/showChecklistOverlay.js'
import showCurrentRisk from '../../Utils/riskStation.js'
import chatbot from '../../Utils/chatbot.js'
import { showQualificationOverlay } from '../../Utils/qualification.js'
import { Howl } from 'howler'
import gsap from 'gsap'

export default class Project
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.name = _options.name
        this.geometries = _options.geometries
        this.meshes = _options.meshes
        this.debug = _options.debug
        this.name = _options.name
        this.x = _options.x
        this.y = _options.y
        this.imageSources = _options.imageSources
        this.floorTexture = _options.floorTexture
        this.floorTextureOffsetX = _options.floorTextureOffsetX
        this.floorTextureOffsetY = _options.floorTextureOffsetY
        this.link = _options.link
        this.distinctions = _options.distinctions
        this.interactionTypes = _options.interactionTypes || []
        this.dragDropOverlayVisible = false
        this.floorTextureLeft = _options.floorTextureLeft
        this.floorTextureLeftOffsetX = _options.floorTextureLeftOffsetX
        this.floorTextureLeftOffsetY = _options.floorTextureLeftOffsetY
        this.audio = null

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        // this.container.updateMatrix()

       // this.setBoards()
        this.setFloor()
        
       // Einmaliges Setup
       window.addEventListener('click', () => {
       if (this.audio) {
        this.audio.play().then(() => {
            this.audio.pause(); 
            this.audio.currentTime = 0; 
        }).catch(() => {
            // Ignorieren, falls blockiert
        });
        }
         }, { once: true });
    }


    showBoards()
    {
       if(this.boardsAdded) return // nur einmal hinzufügen
       this.setBoards()
       this.boardsAdded = true
    }

    showVideo() {
            // Vorheriges Video entfernen, wenn vorhanden
    if (this.videoElement) {
        this.videoElement.pause()
        this.videoElement.src = ''
        this.videoElement.remove()
        this.videoElement = null
    }

    if (this.videoMesh) {
        this.container.remove(this.videoMesh)
        this.videoMesh.geometry.dispose()
        this.videoMesh.material.map.dispose()
        this.videoMesh.material.dispose()
        this.videoMesh = null
    }

    // Neues Video-Element
    const video = document.createElement('video')
    video.src = './audios/videos/meinvideo.mp4'
    video.crossOrigin = 'anonymous'
    video.loop = false
    video.muted = false
    video.autoplay = false
    video.volume = 1.0
    video.playsInline = true
    video.style.display = 'none'
    document.body.appendChild(video) // wichtig für Autoplay auf manchen Browsern

    video.play().catch((e) => {
        console.warn('Video konnte nicht gestartet werden:', e)
    })

    this.videoElement = video
    
        // Videotextur erstellen
        const texture = new THREE.VideoTexture(video)
        texture.minFilter = THREE.LinearFilter
        texture.magFilter = THREE.LinearFilter
        texture.format = THREE.RGBAFormat
    
        // Plane-Geometrie und Material
        const geometry = new THREE.PlaneGeometry(16, 6.5) // 16:9 Format
        const material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            transparent: true
        })
    
        // Mesh erstellen
        this.videoMesh = new THREE.Mesh(geometry, material)
        this.videoMesh.position.set(this.x, this.y + 5, 0) // z.B. über dem Boden
        this.videoMesh.matrixAutoUpdate = false
        this.videoMesh.updateMatrix()
    
        // Zur Szene oder zum Container hinzufügen
        this.container.add(this.videoMesh)
    }

    stopVideo() {
        if (this.videoElement) {
            this.videoElement.pause()
            this.videoElement.src = ''
            this.videoElement.remove()
            this.videoElement = null
        }
    
        if (this.videoMesh) {
            this.container.remove(this.videoMesh)
            this.videoMesh.geometry.dispose()
            this.videoMesh.material.map.dispose()
            this.videoMesh.material.dispose()
            this.videoMesh = null
        }
    }

    showVideo1() {
        // Vorheriges Video entfernen, wenn vorhanden
if (this.videoElement) {
    this.videoElement.pause()
    this.videoElement.src = ''
    this.videoElement.remove()
    this.videoElement = null
}

if (this.videoMesh) {
    this.container.remove(this.videoMesh)
    this.videoMesh.geometry.dispose()
    this.videoMesh.material.map.dispose()
    this.videoMesh.material.dispose()
    this.videoMesh = null
}

// Neues Video-Element
const video = document.createElement('video')
video.src = './audios/videos/meinvideo1.mp4'
video.crossOrigin = 'anonymous'
video.loop = false
video.muted = false
video.autoplay = false
video.volume = 1.0
video.playsInline = true
video.style.display = 'none'
document.body.appendChild(video) // wichtig für Autoplay auf manchen Browsern

video.play().catch((e) => {
    console.warn('Video konnte nicht gestartet werden:', e)
})

this.videoElement = video

    // Videotextur erstellen
    const texture = new THREE.VideoTexture(video)
    texture.minFilter = THREE.LinearFilter
    texture.magFilter = THREE.LinearFilter
    texture.format = THREE.RGBAFormat

    // Plane-Geometrie und Material
    const geometry = new THREE.PlaneGeometry(16, 6.5) // 16:9 Format
    const material = new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.DoubleSide,
        transparent: true
    })

    // Mesh erstellen
    this.videoMesh = new THREE.Mesh(geometry, material)
    this.videoMesh.position.set(this.x-5, this.y + 1, 0) // z.B. über dem Boden
    this.videoMesh.matrixAutoUpdate = false
    this.videoMesh.updateMatrix()

    // Zur Szene oder zum Container hinzufügen
    this.container.add(this.videoMesh)
}

stopVideo1() {
    if (this.videoElement) {
        this.videoElement.pause()
        this.videoElement.src = ''
        this.videoElement.remove()
        this.videoElement = null
    }

    if (this.videoMesh) {
        this.container.remove(this.videoMesh)
        this.videoMesh.geometry.dispose()
        this.videoMesh.material.map.dispose()
        this.videoMesh.material.dispose()
        this.videoMesh = null
    }
}
    

playAudio() {
    // Audio nur einmal erstellen
    if (!this.audio) {
        this.audio = new Audio('/audios/meinaudio.mp3'); // Relativ zum Root
        this.audio.volume = 1.0;
        this.audio.loop = false;
    }

    // Falls es einen AudioContext gibt, wieder aufnehmen
    if (this.audioContext && this.audioContext.state === 'suspended') {
        this.audioContext.resume()
            .catch(e => console.warn('AudioContext konnte nicht fortgesetzt werden:', e));
    }

    // Starten
    if (this.audio.paused) {
        this.audio.play()
            .catch(e => console.warn('Audio konnte nicht abgespielt werden:', e));
    }
}

stopAudio() {
    if (this.audio && !this.audio.paused) {
        this.audio.pause();
        this.audio.currentTime = 0; // auf Anfang zurücksetzen
    }
}


    showDragDropOverlay() {
        showDragDropOverlay()
    }


    hideDragDropOverlay() {
        const overlay = document.getElementById('dragDropOverlay')
        if (overlay) {
            overlay.remove()
        }
    }   
    setBoards()
    {
        // Set up
        this.boards = {}
        this.boards.items = []
        this.boards.xStart = - 5
        this.boards.xInter = 5
        this.boards.y = 5
        this.boards.color = '#8e7161'
        this.boards.threeColor = new THREE.Color(this.boards.color)

        if(this.debug)
        {
            this.debug.addColor(this.boards, 'color').name('boardColor').onChange(() =>
            {
                this.boards.threeColor.set(this.boards.color)
            })
        }

        // Create each board
        let i = 0

        for(const _imageSource of this.imageSources)
        {
            // Set up
            const board = {}
            board.x = this.x + this.boards.xStart + i * this.boards.xInter
            board.y = this.y + this.boards.y

            // Create structure with collision
            this.objects.add({
                base: this.resources.items.projectsBoardStructure.scene,
                collision: this.resources.items.projectsBoardCollision.scene,
                floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture,
                offset: new THREE.Vector3(board.x, board.y, 0),
                rotation: new THREE.Euler(0, 0, 0),
                duplicated: true,
                mass: 0
            })

            // Image load
            const image = new Image()
            image.addEventListener('load', () =>
            {
                board.texture = new THREE.Texture(image)
                 board.texture.magFilter = THREE.NearestFilter
                board.texture.minFilter = THREE.LinearFilter
                board.texture.anisotropy = 4
                 board.texture.colorSpace = THREE.SRGBColorSpace
                board.texture.needsUpdate = true

                board.planeMesh.material.uniforms.uTexture.value = board.texture

                gsap.to(board.planeMesh.material.uniforms.uTextureAlpha, { value: 1, duration: 1, ease: 'power4.inOut' })
            })

            image.src = _imageSource

            // Plane
            board.planeMesh = this.meshes.boardPlane.clone()
            board.planeMesh.position.x = board.x
            board.planeMesh.position.y = board.y
            board.planeMesh.matrixAutoUpdate = false
            board.planeMesh.updateMatrix()
            board.planeMesh.material = new ProjectBoardMaterial()
            board.planeMesh.material.uniforms.uColor.value = this.boards.threeColor
            board.planeMesh.material.uniforms.uTextureAlpha.value = 0
            this.container.add(board.planeMesh)

            // Save
            this.boards.items.push(board)

            i++
        }
    }

    setFloor()
    {
        this.floor = {}

    this.floor.y = -2
    this.floor.x = 0

    // Container
    this.floor.container = new THREE.Object3D()
    this.floor.container.position.x = this.x
    this.floor.container.position.y = this.y + this.floor.y
    this.floor.container.matrixAutoUpdate = false
    this.floor.container.updateMatrix()
    this.container.add(this.floor.container)

    // Geometry
    this.floor.geometry = this.geometries.floor
    //
    // Rechts
    if (this.floorTexture) {
        this.floor.materialRight = new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            alphaMap: this.floorTexture,
            //todo cet opacity=1 and delete wrong floor texts
            opacity: 0 // oder 0, wenn du es erst einblenden willst
        })
        const meshRight = new THREE.Mesh(this.floor.geometry, this.floor.materialRight)
        meshRight.position.x = -8 + (this.floorTextureOffsetX??0)
        meshRight.position.y = -5 + (this.floorTextureOffsetY??0)
        meshRight.matrixAutoUpdate = false
        meshRight.updateMatrix()
        this.floor.container.add(meshRight)
    }

    // Links
    if (this.floorTextureLeft) {
        this.floor.materialLeft = new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            alphaMap: this.floorTextureLeft,
            //todo set opacity 1 and find orphans
            opacity: 0 // oder 0
        })
        const meshLeft = new THREE.Mesh(this.floor.geometry, this.floor.materialLeft)
        meshLeft.position.x = (this.floorTextureLeftOffsetX??0)
        meshLeft.position.y = -10 + (this.floorTextureLeftOffsetY??0)
        meshLeft.matrixAutoUpdate = false
        meshLeft.updateMatrix()
        this.floor.container.add(meshLeft)
    }

        // Distinctions
        if(this.distinctions)
        {
            for(const _distinction of this.distinctions)
            {
                let base = null
                let collision = null
                let shadowSizeX = null
                let shadowSizeY = null

                switch(_distinction.type)
                {
                    case 'awwwards':
                        base = this.resources.items.projectsDistinctionsAwwwardsBase.scene
                        collision = this.resources.items.projectsDistinctionsAwwwardsCollision.scene
                        shadowSizeX = 1.5
                        shadowSizeY = 1.5
                        break

                    case 'fwa':
                        base = this.resources.items.projectsDistinctionsFWABase.scene
                        collision = this.resources.items.projectsDistinctionsFWACollision.scene
                        shadowSizeX = 2
                        shadowSizeY = 1
                        break

                    case 'cssda':
                        base = this.resources.items.projectsDistinctionsCSSDABase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1.2
                        shadowSizeY = 1.2
                        break
                    case 'umsetzung':
                        base = this.resources.items.projectsDistinctionsUmsetzungBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Planung':
                        base = this.resources.items.projectsDistinctionsPlanungBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Umsetzungg':
                        base = this.resources.items.projectsDistinctionsUmsetzunggBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Stabilisierung':
                        base = this.resources.items.projectsDistinctionsStabilisierungBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Evaluation':
                        base = this.resources.items.projectsDistinctionsEvaluationBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Sanduhr':
                        base = this.resources.items.projectsDistinctionsSanduhrBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Aktentasche':
                        base = this.resources.items.projectsDistinctionsAktentascheBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Teleskop':
                        base = this.resources.items.projectsDistinctionsTeleskopBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'Labyrinth':
                        base = this.resources.items.projectsDistinctionsLabyrinthBase.scene
                        collision = this.resources.items.projectsDistinctionsLabyrinthCollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'ki-insel':
                        base = this.resources.items.projectsDistinctionskiinselBase.scene
                        collision = this.resources.items.projectsDistinctionsCSSDACollision.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break
                    case 'chatbot':
                        base = this.resources.items.chatbot.scene
                        collision = this.resources.items.chatbot.scene
                        shadowSizeX = 1
                        shadowSizeY = 1
                        break

                }

                this.objects.add({
                    base: base,
                    collision: collision,
                    offset: new THREE.Vector3(this.x + this.floor.x + _distinction.x, this.y + this.floor.y + _distinction.y, 0),
                    rotation: new THREE.Euler(0, 0, 0),
                    duplicated: true,
                    shadow: { sizeX: shadowSizeX, sizeY: shadowSizeY, offsetZ: - 0.1, alpha: 0.5 },
                    mass: _distinction.mass ?? 1.5, 
                    soundName: 'woodHit'
                })
            }
        }

        // Area
        this.floor.area = this.areas.add({
            position: new THREE.Vector2(this.x + this.link.x, this.y + this.floor.y + this.link.y),
            halfExtents: new THREE.Vector2(this.link.halfExtents.x, this.link.halfExtents.y)
        })

        this.hasScored = false // Zustand merken

        this.floor.area.on('interact', () =>
            {
                if (!this.hasScored) {
                  ScoreManager.add(1)
                 this.hasScored = true // danach kein Punkt mehr
                 }
                const types = this.interactionTypes || []
            
                if (types.includes('link')) {
                    window.open(this.link.href, '_blank')
                }
                if (types.includes('showTexture')) {
                    if (this.floor.materialRight) {
                        gsap.to(this.floor.materialRight, { opacity: 1, duration: 1 })
                    }
                    if (this.floor.materialLeft) {
                        gsap.to(this.floor.materialLeft, { opacity: 1, duration: 1 })
                    }
                }                
                if (types.includes('showBoards')) {
                    this.showBoards()
                }
                if (types.includes('showIntro')) {
                    showIntroOverlay()
                }
                if (types.includes('chatbot')) {
                    chatbot()
                }
                if (types.includes('showStory')) {
                    showStoryDialog()
                }

                if (types.includes('showQuizOverlay')) {
                    showQuizOverlay()
                }

                if (types.includes('riskStation')) {
                    document.getElementById('risk-overlay').style.display = 'block'
                    showCurrentRisk()
                }
                
                if (types.includes('showVideo')) {
                    const scoreOk = showScoreRequirementDialog(5) // z. B. Mindestscore 5
                   if (scoreOk) {
                    this.showVideo()
                   }
                   this.floor.area.on('out', () => {
                    // Video stoppen beim Verlassen der Area
                    this.stopVideo()
                   })
                }
                if (types.includes('showVideo1')) {
                    const scoreOk = showScoreRequirementDialog(0) // z. B. Mindestscore 5
                   if (scoreOk) {
                    this.showVideo1()
                   }
                   this.floor.area.on('out', () => {
                    // Video stoppen beim Verlassen der Area
                    this.stopVideo1()
                })
                }
                if (types.includes('playAudio')) {
                    this.playAudio()
                    this.floor.area.on('out', () => {
                        //audio stoppen beim Verlassen der Area
                        this.stopAudio()
                    })
                }
                if (types.includes('showQAOverlay')) {
                    showQAOverlay()
                }
                if (types.includes('dragDrop')) {
                    // if (!this.dragDropOverlayVisible) {
                        this.showDragDropOverlay()
                    //     this.dragDropOverlayVisible = true
                    // } else {
                    //     this.hideDragDropOverlay()
                    //     this.dragDropOverlayVisible = false
                    // }
                }
                if (types.includes('showDialog')) {
                    showThreejsJourney()
                }
                if (types.includes('showDialog1')) {
                    showThreejsJourney1()
                }
                if (types.includes('qualifikation')) {
                    showQualificationOverlay()
                }
                if (types.includes('kennzahlen')) {
                    showKennzahlenOverlay()
                  }
                  if (types.includes('checklist')) {
                    showChecklistOverlay()
                }
                if (types.includes('wiederstand')) {
                    showWiderstandPopup()
                }
                if (types.includes('Stakeholder')) {
                    showStakeholderOverlay()
                }
                if (types.includes('miroBoard')) {
                    showMiroBoard()
                }
                if (types.includes('zeitplanung')) {
                    showPopupStationOverlay()
                }
            })

        // Area label
        this.floor.areaLabel = this.meshes.areaLabel.clone()
        this.floor.areaLabel.position.x = this.link.x
        this.floor.areaLabel.position.y = this.link.y
        this.floor.areaLabel.position.z = 0.001
        this.floor.areaLabel.matrixAutoUpdate = false
        this.floor.areaLabel.updateMatrix()
        this.floor.container.add(this.floor.areaLabel)
    }
}
